const SE = 'SE';
const NO = 'NO';
const sv = 'sv';
const en = 'en';
const humanReadableFileSize = {
    KB: 1024,
    MB: 1024 * 1024,
    GB: 1024 * 1024,
    TB: 1024 * 1024 * 1024,
};
const getBytesFromHumanReadableFileSize = function (sizeString) {
    const fileSizeChecker = /(\d+\.?\d*)\s?([a-zA-Z]{2})?$/;
    if (fileSizeChecker.test(sizeString)) {
        const matches = sizeString.match(fileSizeChecker);
        const unit = (matches[2] || '').toLocaleUpperCase();
        const size = parseInt(matches[1]);
        if (unit && humanReadableFileSize[unit]) {
            const baseSize = humanReadableFileSize[unit];
            return size * baseSize;
        }
        return size;
    }
    return 0;
};
const uuidv4 = () => crypto.randomUUID();

export { NO as N, SE as S, en as e, getBytesFromHumanReadableFileSize as g, sv as s, uuidv4 as u };

//# sourceMappingURL=helpers-7bea9f35.js.map